function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m45.941406 147.789062h21.320313c4.136719 0 7.492187-3.355468 7.492187-7.492187 0-4.140625-3.355468-7.496094-7.492187-7.496094h-21.320313c-4.140625 0-7.496094 3.355469-7.496094 7.496094 0 4.136719 3.355469 7.492187 7.496094 7.492187zm0 0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m221.21875 132.800781h-130.082031c-4.136719 0-7.492188 3.355469-7.492188 7.496094 0 4.136719 3.355469 7.492187 7.492188 7.492187h130.082031c4.140625 0 7.496094-3.355468 7.496094-7.492187 0-4.140625-3.355469-7.496094-7.496094-7.496094zm0 0"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m201.460938 170.785156h-47.570313c-4.140625 0-7.496094 3.351563-7.496094 7.492188s3.355469 7.492187 7.496094 7.492187h47.570313c4.136718 0 7.492187-3.351562 7.492187-7.492187s-3.355469-7.492188-7.492187-7.492188zm0 0"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m129.007812 170.785156h-14.828124c-4.136719 0-7.492188 3.351563-7.492188 7.492188s3.355469 7.492187 7.492188 7.492187h14.828124c4.140626 0 7.496094-3.351562 7.496094-7.492187s-3.355468-7.492188-7.496094-7.492188zm0 0"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m90.316406 170.785156h-44.375c-4.140625 0-7.496094 3.351563-7.496094 7.492188s3.355469 7.492187 7.496094 7.492187h44.375c4.136719 0 7.492188-3.351562 7.492188-7.492187s-3.355469-7.492188-7.492188-7.492188zm0 0"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "m33.273438 50.753906c0 12.125 9.863281 21.988282 21.988281 21.988282s21.992187-9.863282 21.992187-21.988282-9.867187-21.992187-21.992187-21.992187-21.988281 9.867187-21.988281 21.992187zm28.992187 0c0 3.859375-3.144531 7.003906-7.003906 7.003906-3.863281 0-7.003907-3.144531-7.003907-7.003906 0-3.863281 3.140626-7.003906 7.003907-7.003906 3.859375 0 7.003906 3.140625 7.003906 7.003906zm0 0"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "m89.257812 50.753906c0 12.125 9.867188 21.988282 21.992188 21.988282s21.988281-9.863282 21.988281-21.988282-9.863281-21.992187-21.988281-21.992187-21.992188 9.867187-21.992188 21.992187zm28.992188 0c0 3.859375-3.140625 7.003906-7.003906 7.003906-3.859375 0-7.003906-3.144531-7.003906-7.003906 0-3.863281 3.144531-7.003906 7.003906-7.003906 3.863281 0 7.003906 3.140625 7.003906 7.003906zm0 0"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "m145.246094 50.753906c0 12.125 9.863281 21.988282 21.988281 21.988282s21.988281-9.863282 21.988281-21.988282-9.863281-21.992187-21.988281-21.992187-21.988281 9.867187-21.988281 21.992187zm28.992187 0c0 3.859375-3.140625 7.003906-7.003906 7.003906-3.859375 0-7.003906-3.144531-7.003906-7.003906 0-3.863281 3.144531-7.003906 7.003906-7.003906 3.863281 0 7.003906 3.140625 7.003906 7.003906zm0 0"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "m416.457031 492.71875h25.011719c4.136719 0 7.492188-3.355469 7.492188-7.492188 0-4.140624-3.355469-7.496093-7.492188-7.496093h-25.011719c-4.140625 0-7.496093 3.355469-7.496093 7.496093 0 4.136719 3.355468 7.492188 7.496093 7.492188zm0 0"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "m414.277344 233.851562h-8.625c-4.136719 0-7.492188 3.351563-7.492188 7.492188s3.355469 7.492188 7.492188 7.492188h8.625c4.140625 0 7.496094-3.351563 7.496094-7.492188s-3.355469-7.492188-7.496094-7.492188zm0 0"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "m452.269531 233.851562h-16.949219c-4.136718 0-7.492187 3.351563-7.492187 7.492188s3.355469 7.492188 7.492187 7.492188h16.949219c4.136719 0 7.492188-3.351563 7.492188-7.492188s-3.355469-7.492188-7.492188-7.492188zm0 0"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "m511.429688 32.980469c0-18.183594-14.792969-32.980469-32.976563-32.980469h-63.929687c-4.140626 0-7.492188 3.355469-7.492188 7.492188 0 4.140624 3.351562 7.496093 7.492188 7.496093h63.929687c9.921875 0 17.992187 8.070313 17.992187 17.992188v53.960937h-481.457031v-53.960937c0-9.921875 8.070313-17.992188 17.992188-17.992188h334.917969c4.140624 0 7.492187-3.355469 7.492187-7.496093 0-4.136719-3.351563-7.492188-7.492187-7.492188h-334.917969c-18.1875 0-32.980469 14.796875-32.980469 32.980469v362.566406c0 18.183594 14.792969 32.980469 32.980469 32.980469h145.804687v26.871094h-22.625c-15.09375 0-27.371094 12.28125-27.371094 27.371093v16.1875c0 6.886719 5.601563 12.492188 12.488282 12.492188l347.285156.457031c12.925781 0 23.4375-10.515625 23.4375-23.4375v-23.707031zm-478.449219 380.558593c-9.921875 0-17.992188-8.070312-17.992188-17.992187v-28.421875h330.933594v46.414062zm299.664062 14.988282h13.277344v26.871094h-13.277344zm-14.984375 0v26.871094h-123.890625v-26.871094zm-173.886718 67.933594v-13.691407c0-6.824219 5.558593-12.382812 12.386718-12.382812h189.761719v18.082031c0 2.804688.496094 5.496094 1.40625 7.992188zm353.238281-7.992188c0 4.660156-3.789063 8.449219-8.449219 8.449219h-119.203125c-4.660156 0-8.449219-3.789063-8.449219-8.449219v-16.214844h136.101563zm0-31.203125h-136.101563v-130.710937c0-4.136719-3.355468-7.492188-7.492187-7.492188-4.140625 0-7.496094 3.355469-7.496094 7.492188v25.582031h-330.933594v-250.207031h481.457031v114.667968c-2.464843-.882812-5.117187-1.367187-7.882812-1.367187h-119.203125c-12.921875 0-23.4375 10.515625-23.4375 23.4375v42.261719c0 4.140624 3.355469 7.492187 7.496094 7.492187 4.136719 0 7.492187-3.351563 7.492187-7.492187v-11.058594h136.101563zm0-202.378906h-136.101563v-16.21875c0-4.65625 3.789063-8.449219 8.449219-8.449219h119.203125c4.660156 0 8.453125 3.792969 8.453125 8.449219v16.21875zm0 0"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "m376.027344 306.785156h27.625c4.136718 0 7.492187-3.355468 7.492187-7.492187 0-4.140625-3.355469-7.496094-7.492187-7.496094h-27.625c-4.140625 0-7.492188 3.355469-7.492188 7.496094 0 4.136719 3.351563 7.492187 7.492188 7.492187zm0 0"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "m425.117188 306.785156h11.785156c4.136718 0 7.492187-3.355468 7.492187-7.492187 0-4.140625-3.355469-7.496094-7.492187-7.496094h-11.785156c-4.136719 0-7.492188 3.355469-7.492188 7.496094 0 4.136719 3.355469 7.492187 7.492188 7.492187zm0 0"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "m456.601562 306.785156h25.292969c4.140625 0 7.496094-3.355468 7.496094-7.492187 0-4.140625-3.355469-7.496094-7.496094-7.496094h-25.292969c-4.136718 0-7.492187 3.355469-7.492187 7.496094 0 4.136719 3.355469 7.492187 7.492187 7.492187zm0 0"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "m376.027344 340.480469h12.292968c4.140626 0 7.496094-3.355469 7.496094-7.496094 0-4.136719-3.355468-7.492187-7.496094-7.492187h-12.292968c-4.140625 0-7.492188 3.355468-7.492188 7.492187 0 4.140625 3.351563 7.496094 7.492188 7.496094zm0 0"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "m451.671875 332.984375c0-4.136719-3.351563-7.492187-7.492187-7.492187h-35.183594c-4.136719 0-7.492188 3.355468-7.492188 7.492187 0 4.140625 3.355469 7.496094 7.492188 7.496094h35.183594c4.140624 0 7.492187-3.355469 7.492187-7.496094zm0 0"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "m481.894531 325.492188h-13.894531c-4.136719 0-7.492188 3.355468-7.492188 7.492187 0 4.140625 3.355469 7.496094 7.492188 7.496094h13.894531c4.140625 0 7.496094-3.355469 7.496094-7.496094 0-4.136719-3.355469-7.492187-7.496094-7.492187zm0 0"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "m376.027344 371.480469h24.589844c4.136718 0 7.492187-3.355469 7.492187-7.492188 0-4.140625-3.355469-7.496093-7.492187-7.496093h-24.589844c-4.140625 0-7.492188 3.355468-7.492188 7.496093 0 4.136719 3.351563 7.492188 7.492188 7.492188zm0 0"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "m421.136719 371.480469h31.132812c4.136719 0 7.492188-3.355469 7.492188-7.492188 0-4.140625-3.355469-7.496093-7.492188-7.496093h-31.132812c-4.140625 0-7.496094 3.355468-7.496094 7.496093 0 4.136719 3.355469 7.492188 7.496094 7.492188zm0 0"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "m481.894531 356.492188h-9.5625c-4.136719 0-7.492187 3.355468-7.492187 7.496093 0 4.136719 3.355468 7.492188 7.492187 7.492188h9.5625c4.140625 0 7.496094-3.355469 7.496094-7.492188 0-4.140625-3.355469-7.496093-7.496094-7.496093zm0 0"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "m376.027344 405.175781h37.613281c4.140625 0 7.496094-3.355469 7.496094-7.496093 0-4.136719-3.355469-7.492188-7.496094-7.492188h-37.613281c-4.140625 0-7.492188 3.355469-7.492188 7.492188 0 4.140624 3.351563 7.496093 7.492188 7.496093zm0 0"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "m445.09375 390.1875h-10.191406c-4.136719 0-7.492188 3.355469-7.492188 7.492188 0 4.140624 3.355469 7.496093 7.492188 7.496093h10.191406c4.136719 0 7.492188-3.355469 7.492188-7.496093 0-4.136719-3.355469-7.492188-7.492188-7.492188zm0 0"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "m481.894531 390.1875h-17.757812c-4.136719 0-7.492188 3.355469-7.492188 7.492188 0 4.140624 3.355469 7.496093 7.492188 7.496093h17.757812c4.140625 0 7.496094-3.355469 7.496094-7.496093 0-4.136719-3.355469-7.492188-7.496094-7.492188zm0 0"
});

var SvgItWebAndDesign = function SvgItWebAndDesign(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgItWebAndDesign, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/it-web-and-design.0914748a.svg";
export { ForwardRef as ReactComponent };